import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { Application, Feature } from '@frontend/functionality/types';

import { TransactionType } from './transaction';

export enum TransactionTimerName {
    TRANSACTION_DROP_OFF_PENDING = 'transaction_drop_off_pending',
    TRANSACTION_PICK_UP_PENDING = 'transaction_pick_up_pending'
}

export interface TransactionTimer {
    application: Application | null;
    feature: Feature | null;
    type: TransactionType | null;
    spot_id: string | null;
    current_spot_id: string | null;
    duration: number | null;
    end_timestamp: string | null;
    cancel_timestamp: string | null;
    name: string;
    start_timestamp: string;
    id: string;
    account_id: string;
    transaction_id: string;
    creation_timestamp: string;
    update_timestamp: string;
}

export interface CreateTransactionTimer {
    name: string;
    application?: Application | null;
    feature?: Feature | null;
    type?: TransactionType | null;
    spot_id?: string | null;
    current_spot_id?: string | null;
    duration?: number | null;
    end_timestamp?: string | null;
    cancel_timestamp?: string | null;
    start_timestamp?: string;
}

export interface UpdateTransactionTimer {
    application?: Application | null;
    feature?: Feature | null;
    type?: TransactionType | null;
    spot_id?: string | null;
    current_spot_id?: string | null;
    duration?: number | null;
    end_timestamp?: string | null;
    cancel_timestamp?: string | null;
    null_fields?: string[] | null;
}

export type TransactionTimerListResponse = PaginatedResponse<TransactionTimer>;

enum QueryParams {
    NAME = 'name',
    APPLICATION = 'application',
    FEATURE = 'feature',
    TYPE = 'type',
    SPOT_ID = 'spot_id',
    TRANSACTION_ID = 'transaction_id'
}

export type TransactionTimerQueryParams = DefaultQueryParams | QueryParams;
